/* ==========================================================================
   FORTE · CART DRAWER x DISCOUNT NINJA

   Discount Ninja applies the free gifts at checkout, so Shopify's own cart data
   (which the drawer renders) may still hold the gift at full price, or already
   at $0. This file reads Discount Ninja's discounted cart (la:dn:cart:updated,
   the documented public event) and
     1. shows each discounted gift line as FREE with the old price struck through,
     2. makes the drawer total match checkout (without counting a gift twice),
     3. swaps the progress bar for the promo reward ladder while the promo runs.

   It only edits the drawer after forte-cart.js has rendered it and never touches
   the checkout button. If Discount Ninja is absent nothing here changes.

   Preview helpers (URL params):
     ?fc_promo=1  show the reward ladder outside the promo dates
     ?fc_debug=1  log Discount Ninja's cart next to Shopify's in the console
                  (also: window.__fcDN() returns both at any time)
   ========================================================================== */

(function () {
  'use strict';

  var CONFIG = {
    /* Oct 24 00:00 ET -> end of Nov 9 ET (Nov 10 00:00 EST). */
    start: '2026-10-24T04:00:00Z',
    end: '2026-11-10T05:00:00Z',
    tiers: [
      { at: 54,  kind: 'gift', name: 'Boar Bristle Brush' },
      { at: 74,  kind: 'ship', name: 'Free Shipping' },
      { at: 94,  kind: 'gift', name: 'Santos Dopp Kit' },
      { at: 144, kind: 'gift', name: 'Protagonist Fragrance' },
      { at: 184, kind: 'gift', name: 'Antagonist + Atomizer' }
    ],
    noteNext: 'Add {amount} to unlock {reward}',
    noteDone: 'Every reward unlocked',
    badge: 'Free Gift'
  };

  var dn = null;      /* latest Discount Ninja discounted cart */
  var cart = null;    /* latest Shopify cart.js */
  var running = false;
  var again = false;
  var rootObs = null;
  var hostObs = null;

  /* ------------------------------------------------------------- helpers */

  function root() { return document.querySelector('[data-fc]'); }

  function flag(name) { return new RegExp('[?&]' + name + '=1').test(window.location.search); }

  function promoOn() {
    if (flag('fc_promo')) return true;
    var now = Date.now();
    return now >= Date.parse(CONFIG.start) && now < Date.parse(CONFIG.end);
  }

  /* The store's own money format, without the currency code, so amounts read
     like the drawer's other prices. */
  function fmt(cents) {
    var f = (window.theme && (window.theme.moneyWithoutCurrencyFormat || window.theme.moneyFormat)) || '${{amount}}';
    var parts = (Math.max(0, cents) / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = f
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
    return out.replace(/<[^>]*>/g, '');
  }

  function idOf(v) { return String(v == null ? '' : v).split('/').pop(); }
  function num(v) { return typeof v === 'number' && isFinite(v); }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  window.__fcDN = function () { return { dn: dn, cart: cart }; };

  /* ----------------------------------------------------- Discount Ninja data */

  function takeEvent(e) {
    var d = e && e.detail && e.detail.data && e.detail.data[0];
    if (!d) return;
    dn = d;
    run();
  }

  ['la:dn:cart:updated', 'la:dn:cart:discounted'].forEach(function (n) {
    document.addEventListener(n, takeEvent);
  });

  /* Page load: the event may have fired before this file ran. The discounted
     cart accessor is marked debug-only by Discount Ninja, so it is only a
     one-time fallback and every read is guarded. */
  function bootstrapFromApi() {
    if (dn) return;
    try {
      var d = window.discountNinja && window.discountNinja.api &&
        window.discountNinja.api.discountedCart && window.discountNinja.api.discountedCart.content;
      if (d && d.items) dn = d;
    } catch (err) {}
  }

  /* How many cents Discount Ninja takes off one drawer line (capped at its full
     price). */
  function lineOff(m, was) {
    if (!m) return 0;
    if (m.isGift) return was;
    var off = 0;
    if (m.discount && m.discount.line && num(Number(m.discount.line.amount))) off = Number(m.discount.line.amount);
    if (!off && m.price && m.price.line && num(m.price.line.original) && num(m.price.line.discounted)) {
      off = m.price.line.original - m.price.line.discounted;
    }
    return Math.min(Math.max(off, 0), was);
  }

  /* Pair a drawer line with Discount Ninja's item for it: variant first, then
     the line key, then product id, then product handle. Each item is used once. */
  function match(it, used) {
    if (!dn || !dn.items) return null;
    var tests = [
      function (m) { return idOf(m.variantId != null ? m.variantId : (m.variant_id != null ? m.variant_id : m.variant && m.variant.id)) === idOf(it.variant_id); },
      function (m) { return m.key != null && String(m.key) === String(it.key); },
      function (m) { return (m.productId != null || m.product_id != null) && idOf(m.productId != null ? m.productId : m.product_id) === idOf(it.product_id); },
      function (m) { var h = m.productHandle || m.handle || m.product_handle; return !!h && h === it.handle; }
    ];
    for (var t = 0; t < tests.length; t++) {
      for (var j = 0; j < dn.items.length; j++) {
        if (used[j]) continue;
        if (tests[t](dn.items[j])) { used[j] = true; return dn.items[j]; }
      }
    }
    return null;
  }

  /* Fallback for when Discount Ninja reports a discount on the whole cart but a
     line could not be paired: the free items are the unpaired lines whose prices
     add up exactly to the discount (fewest lines wins). */
  function freeSubset(list, target) {
    var n = list.length;
    if (!n || n > 12 || target <= 0) return [];
    var best = null;
    var bestCount = 99;
    for (var mask = 1; mask < (1 << n); mask++) {
      var sum = 0;
      var count = 0;
      for (var i = 0; i < n; i++) {
        if (mask & (1 << i)) { sum += list[i].it.final_line_price; count++; }
      }
      if (sum === target && count < bestCount) { best = mask; bestCount = count; }
    }
    var out = [];
    if (best) for (var k = 0; k < n; k++) if (best & (1 << k)) out.push(list[k]);
    return out;
  }

  /* -------------------------------------------------------------- painting */

  function restore(row) {
    var st = row.__fcdn;
    if (!st) return;
    var money = row.querySelector('.fc-li__money');
    if (money) money.innerHTML = st.html;
    row.classList.remove('fc-li--dn-gift');
    if (st.addedGiftClass) row.classList.remove('fc-li--gift');
    var b = row.querySelector('.fc-li__gift--dn');
    if (b) b.parentNode.removeChild(b);
    row.__fcdn = null;
  }

  /* final: what Shopify charges for the line now; eff: how much more Discount
     Ninja takes off; was: the line's full price (struck through). */
  function markRow(row, m, final, eff, was) {
    var money = row.querySelector('.fc-li__money');
    if (!money) return;
    row.__fcdn = { html: money.innerHTML, addedGiftClass: !row.classList.contains('fc-li--gift') };

    var left = Math.max(0, final - eff);
    if (left <= 0) {
      money.innerHTML = '<span class="fc-li__price fc-li__price--free">FREE</span><s class="fc-li__was">' + esc(fmt(was)) + '</s>';
    } else {
      money.innerHTML = '<span class="fc-li__price">' + esc(fmt(left)) + '</span><s class="fc-li__was">' + esc(fmt(was)) + '</s>';
    }

    if (m.isGift) {
      row.classList.add('fc-li--gift', 'fc-li--dn-gift');
      var title = row.querySelector('.fc-li__title');
      if (title && !title.querySelector('.fc-li__gift')) {
        var badge = document.createElement('span');
        badge.className = 'fc-li__gift fc-li__gift--dn';
        badge.innerHTML = '<span>' + esc(CONFIG.badge) + '</span>';
        title.appendChild(badge);
      }
    }
  }

  var ICON = {
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" d="M4 11h16v9H4zM3 7.5h18V11H3zM12 7.5V20M12 7.5C10 7.5 8 6.6 8 5.2 8 4 9 3.5 10 3.8c1.2.4 2 2.2 2 3.7zm0 0c2 0 4-.9 4-2.3 0-1.2-1-1.7-2-1.4-1.2.4-2 2.2-2 3.7z"/></svg>',
    ship: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" d="M2 6h11v10H2zM13 9.5h4.5L21 13v3h-8zM6.5 18.5a1.8 1.8 0 1 0 0-.01zM17 18.5a1.8 1.8 0 1 0 0-.01z"/></svg>'
  };

  function tierPct(t) {
    var max = CONFIG.tiers[CONFIG.tiers.length - 1].at;
    return (t.at / max) * 100;
  }

  function ladderHtml() {
    var nodes = '';
    var labels = '';
    CONFIG.tiers.forEach(function (t) {
      var p = tierPct(t).toFixed(3) + '%';
      nodes += '<span class="fc__node fc__node--ld" data-ld-at="' + t.at + '" style="--p:' + p + '" title="' + esc(t.name) + '">' + ICON[t.kind] + '</span>';
      labels += '<span data-ld-lbl="' + t.at + '" style="--p:' + p + '">$' + t.at + '</span>';
    });
    return '<p class="fc__prog-note" data-ld-note></p>' +
      '<div class="fc__meter fc__meter--ladder" data-ld-meter style="--fc-pct:0%">' +
      '<span class="fc__track" aria-hidden="true"></span>' +
      '<span class="fc__fill" role="progressbar" aria-label="Progress to your rewards" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"></span>' +
      nodes + '</div>' +
      '<div class="fc__ladder-labels" data-ld-labels>' + labels + '</div>';
  }

  function paintLadder(r, spend) {
    var prog = r.querySelector('.fc__prog');
    if (!prog) return;
    if (!prog.querySelector('[data-ld-meter]')) {
      prog.classList.remove('is-unlocked');
      prog.innerHTML = ladderHtml();
    }
    var max = CONFIG.tiers[CONFIG.tiers.length - 1].at * 100;
    var pct = Math.max(0, Math.min(100, (spend * 100) / max));
    var meter = prog.querySelector('[data-ld-meter]');
    meter.style.setProperty('--fc-pct', pct + '%');
    var bar = meter.querySelector('.fc__fill');
    if (bar) bar.setAttribute('aria-valuenow', Math.round(pct));

    var next = null;
    CONFIG.tiers.forEach(function (t) {
      var hit = t.at * 100 <= spend;
      var n = meter.querySelector('[data-ld-at="' + t.at + '"]');
      var l = prog.querySelector('[data-ld-lbl="' + t.at + '"]');
      if (n) n.classList.toggle('is-hit', hit);
      if (l) l.classList.toggle('is-hit', hit);
      if (!hit && !next) next = t;
    });

    var note = prog.querySelector('[data-ld-note]');
    if (note) {
      note.textContent = next
        ? CONFIG.noteNext.replace('{amount}', fmt(next.at * 100 - spend)).replace('{reward}', next.name)
        : CONFIG.noteDone;
    }
  }

  function paint(c) {
    var r = root();
    if (!r || !c) return;

    var rows = r.querySelectorAll('[data-fc-line]');
    var used = {};
    var sumRaw = 0;   /* what Discount Ninja says it takes off the paired lines */
    var sumEff = 0;   /* the part of that Shopify's own cart does not already apply */
    var unpaired = [];

    [].forEach.call(rows, function (row) {
      var it = c.items[Number(row.getAttribute('data-fc-line')) - 1];
      restore(row);
      if (!it) return;
      var m = match(it, used);
      if (!m) { unpaired.push({ row: row, it: it }); return; }

      /* The line's full price: Shopify's own figure, or Discount Ninja's when
         Shopify already shows the gift at $0. */
      var was = Math.max(it.original_line_price, it.final_line_price,
        (m.price && m.price.line && num(m.price.line.original)) ? m.price.line.original : 0);
      var raw = lineOff(m, was);
      var eff = Math.min(Math.max(raw - (was - it.final_line_price), 0), it.final_line_price);
      sumRaw += raw;
      sumEff += eff;
      if (m.isGift || raw > 0) markRow(row, m, it.final_line_price, eff, was);
    });

    /* What Discount Ninja takes off the whole cart, when it says. */
    var totalDiff = 0;
    if (dn && dn.total && num(dn.total.originalPrice) && num(dn.total.discountedPrice)) {
      totalDiff = dn.total.originalPrice - dn.total.discountedPrice;
    }

    /* A discount on the cart that no paired line explains: find the free lines. */
    if (totalDiff > sumRaw && unpaired.length) {
      freeSubset(unpaired, totalDiff - sumRaw).forEach(function (u) {
        var was = Math.max(u.it.original_line_price, u.it.final_line_price);
        markRow(u.row, { isGift: true }, u.it.final_line_price, u.it.final_line_price, was);
        sumRaw += u.it.final_line_price;
        sumEff += u.it.final_line_price;
      });
    }

    /* Anything left over is an order-level Discount Ninja discount. */
    var extra = Math.max(0, totalDiff - sumRaw);
    var saved = sumRaw + extra;
    var dnOff = Math.min(sumEff + extra, c.total_price);
    var total = c.total_price - dnOff;

    if (flag('fc_debug')) {
      console.log('[fc-dn]', { dn: dn, shopifyItems: c.items.map(function (i) { return { variant_id: i.variant_id, product_id: i.product_id, handle: i.handle, key: i.key, original: i.original_line_price, final: i.final_line_price }; }), sumRaw: sumRaw, sumEff: sumEff, totalDiff: totalDiff, shopifyTotal: c.total_price, total: total });
    }

    if (saved > 0) {
      var tv = r.querySelector('.fc__row--total .fc__v');
      if (tv) tv.textContent = fmt(total);

      var totals = r.querySelector('.fc__totals');
      if (totals) {
        var row = totals.querySelector('[data-dn-save]');
        if (!row) {
          row = document.createElement('div');
          row.className = 'fc__row';
          row.setAttribute('data-dn-save', '');
          row.innerHTML = '<span class="fc__k">Gift savings</span><span class="fc__v"></span>';
          totals.insertBefore(row, totals.firstChild);
        }
        row.querySelector('.fc__v').textContent = '-' + fmt(saved);
      }
    } else {
      var stale = r.querySelector('[data-dn-save]');
      if (stale) stale.parentNode.removeChild(stale);
    }

    if (promoOn()) paintLadder(r, total);
  }

  /* -------------------------------------------------------------- scheduling */

  function run() {
    if (running) { again = true; return; }
    running = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (c) { cart = c; paint(c); })
      .catch(function () {})
      .then(function () {
        running = false;
        if (again) { again = false; run(); }
      });
  }

  /* The drawer replaces its whole root after every change, and the section
     wrapper's direct children are all that changes, so this is cheap and cannot
     loop on this file's own edits. */
  function onRootsChanged() {
    watchOpen();
    var r = root();
    if (r && cart && r.querySelectorAll('[data-fc-line]').length === cart.items.length) paint(cart);
    run();
  }

  /* Tell Discount Ninja the drawer opened so it refreshes its prices. */
  function watchOpen() {
    var r = root();
    if (!r) return;
    if (rootObs) rootObs.disconnect();
    rootObs = new MutationObserver(function () {
      var cur = root();
      if (cur && !cur.hidden) {
        document.dispatchEvent(new CustomEvent('la:dn:drawercart:opened'));
        run();
      }
    });
    rootObs.observe(r, { attributes: true, attributeFilter: ['hidden'] });
  }

  function start() {
    var host = document.getElementById('shopify-section-forte-cart-drawer');
    if (!host) return;
    bootstrapFromApi();
    hostObs = new MutationObserver(onRootsChanged);
    hostObs.observe(host, { childList: true });
    watchOpen();
    run();

    /* Discount Ninja may load after this file; keep checking briefly. */
    var tries = 0;
    var t = setInterval(function () {
      if (!dn) bootstrapFromApi();
      if (dn) { clearInterval(t); run(); }
      else if (++tries >= 20) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
